import { render, staticRenderFns } from "./HomeValueProposition.vue?vue&type=template&id=53da7c70&scoped=true&"
import script from "./HomeValueProposition.vue?vue&type=script&lang=js&"
export * from "./HomeValueProposition.vue?vue&type=script&lang=js&"
import style0 from "./HomeValueProposition.vue?vue&type=style&index=0&id=53da7c70&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53da7c70",
  null
  
)

export default component.exports